import DiagramUtils from "../../designer/utils/DiagramUtils";

export default class ActionDraw {

    constructor(designer, {
        modelType = "PlotRectangleModel"
    } = {}) {

        this.designer = designer;
        this.modelType = modelType;
    }

    install() {

        const dom = this.designer.dom;
        dom.addEventListener("mousedown", this.onMouseDownHandler = this.onMouseDown.bind(this));
        dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
        dom.addEventListener("mousemove", this.onMouseMoveHandler = this.onMouseMove.bind(this));
        this.designer.cursor("copy");
    }

    uninstall() {

        this.shutdown = true;

        const dom = this.designer.dom;
        dom.removeEventListener("mousedown", this.onMouseDownHandler);
        dom.removeEventListener("mouseup", this.onMouseUpHandler);
        dom.removeEventListener("mousemove", this.onMouseMoveHandler);
        this.isDragging = false;
        this.designer.properties.isDiagramDragging = false;
        this.designer.properties.isDiagramLinking = false;
        this.designer.cursor();
    }

    onMouseDown(e) {

        if (e.button !== 0)
            return;
        if (!this.modelType)
            return;
        if (this.model)
            return;

        this.designer.properties.isDiagramDragging = true;
        this.designer.properties.isDiagramLinking = true;
        this.isDragging = true;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        this.backupMouseStart = pt;

        const meta = DiagramUtils.getModelMetadata(this.modelType);
        this.model = meta.createModel();
        this.model.x = Math.round(pt.x);
        this.model.y = Math.round(pt.y);
        this.model.width = 1;
        this.model.height = 1;

        this.designer.addModel(this.model);
        e.preventDefault();
        e.stopPropagation();
    }

    onMouseUp(e) {

        if (e.button !== 0)
            return;
        if (!this.isDragging)
            return;

        this.designer.properties.isDiagramDragging = false;
        this.designer.properties.isDiagramLinking = false;
        this.isDragging = false;

        this.designer.selectedItems = this.model;
        this.model = null;

        e.preventDefault();
        e.stopPropagation();
        this.designer.action = null;
    }

    onMouseMove(e) {

        if (!this.isDragging)
            return;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        this.model.width = Math.round(Math.max(1, pt.x - this.backupMouseStart.x)) - 1;
        this.model.height = Math.round(Math.max(1, pt.y - this.backupMouseStart.y)) - 1;

        e.preventDefault();
        e.stopPropagation();
    }

}